import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { withKeys as _withKeys, withModifiers as _withModifiers, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "cursor-default mb-2"
}
const _hoisted_2 = {
  key: 1,
  class: "flex gap-2 flex-wrap max-w-50"
}
const _hoisted_3 = {
  key: 2,
  class: "text-neutral2-500"
}

import {computed, ref} from "vue";
import Icon from "../Icon/Icon.vue";
import {IconName} from "../Icon/icons";
import CheckBox from "./CheckBox.vue";
import Dropdown from "./Dropdown.vue";
import {clamp} from "./DropdownMultiple";
import {DropdownOption} from "./DropdownOption";
import TagName from "./TagName.vue";
import TextField from "./TextField.vue";

interface Props {
  nested?: boolean;
  testId?: string;
  title: string;
  icon: IconName;
  options: DropdownOption<T>[];
  blip?: string;
  openToLeft?: boolean;
  search?: boolean;
}

type SearchField = InstanceType<typeof TextField>;
type OptionElement = InstanceType<typeof CheckBox>;

export default /*@__PURE__*/_defineComponent({
  __name: 'DropdownMultiple',
  props: /*@__PURE__*/_mergeModels({
    nested: { type: Boolean },
    testId: {},
    title: {},
    icon: {},
    options: {},
    blip: {},
    openToLeft: { type: Boolean },
    search: { type: Boolean }
  }, {
    "modelValue": {type: Array, required: true},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const props = __props;
const model = _useModel<T[]>(__props, "modelValue");

function selected(value: T): boolean {
  return model.value.includes(value);
}

function toggle(value: T, checked: boolean): void {
  if (checked) {
    model.value.push(value);
  } else {
    model.value.splice(model.value.indexOf(value), 1);
  }
}

function toggleAndDeselect(value: T, checked: boolean): void {
  toggle(value, checked);
  selectedItemIndex.value = -1;
}

const valuesCount = computed((): string|undefined => {
  if (model.value.length === 0) {
    return undefined;
  }
  return model.value.length.toString();
});

const searchPhrase = ref<string>('');
const searchField = ref<SearchField>();

const allFilteredOut = computed((): boolean => filteredOptions.value.length === 0);
const filteredOptions = computed((): DropdownOption<T>[] => {
  const tags = tagsInSearchPhrase(searchPhrase.value.toLowerCase());
  if (!tags.length) {
    return props.options;
  }
  return tags.flatMap(tag => {
    return props.options
      .filter(option => option.title.toLowerCase().includes(tag))
      .toSorted((a, b): number => searchScore(a.title, tag) - searchScore(b.title, tag));
  });
});

function searchScore(item: string, searchPhrase: string): number {
  return item.indexOf(searchPhrase);
}

function tagsInSearchPhrase(searchPhrase: string): string[] {
  return searchPhrase
    .split(/[,; ]/g)
    .map(tag => tag.trim())
    .filter(tag => tag.length);
}

const selectedItemIndex = ref<number>(-1);

const optionElements = ref<Record<string, OptionElement>>({});

function cruseSelectedItemIndex(step: number): void {
  selectedItemIndex.value = clamp(
    selectedItemIndex.value + step,
    0,
    filteredOptions.value.length - 1);
  elementScrollIntoView(selectedOption.value!);
}

function toggleSelectedItem(): void {
  const value = selectedOption.value!.value;
  toggle(value, !isToggled(value));
}

const selectedOption = computed((): DropdownOption<T>|null => {
  if (selectedItemIndex.value === -1) {
    return null;
  }
  return filteredOptions.value[selectedItemIndex.value];
});

function isToggled(value: T): boolean {
  return model.value.indexOf(value) > -1;
}

function setOptionItem(option: DropdownOption<T>, element: OptionElement): void {
  optionElements.value[option.value] = element;
}

function elementScrollIntoView(option: DropdownOption<T>): void {
  optionElements.value![option.value].scrollIntoView();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Dropdown, {
    scroll: "scrollablePadding",
    nested: _ctx.nested,
    "test-id": props.testId,
    title: props.title,
    icon: props.icon,
    blip: valuesCount.value,
    "open-to-left": props.openToLeft,
    onKeydown: [
      _cache[4] || (_cache[4] = _withKeys(($event: any) => (cruseSelectedItemIndex(+1)), ["down"])),
      _cache[5] || (_cache[5] = _withKeys(($event: any) => (cruseSelectedItemIndex(-1)), ["up"])),
      _cache[6] || (_cache[6] = _withKeys(($event: any) => (toggleSelectedItem()), ["enter"]))
    ],
    onKeydownCapture: _cache[7] || (_cache[7] = _withKeys(_withModifiers(($event: any) => (toggleSelectedItem()), ["prevent"]), ["space"]))
  }, {
    default: _withCtx(() => [
      (_ctx.search)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(TextField, {
              "gain-focus": "",
              ref_key: "searchField",
              ref: searchField,
              placeholder: "Wyszukaj...",
              onKeydown: [
                _cache[0] || (_cache[0] = _withKeys(($event: any) => (searchPhrase.value = ''), ["esc"])),
                _cache[1] || (_cache[1] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["down"])),
                _cache[2] || (_cache[2] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["up"]))
              ],
              modelValue: searchPhrase.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((searchPhrase).value = $event))
            }, null, 8 /* PROPS */, ["modelValue"])
          ]))
        : _createCommentVNode("v-if", true),
      (_ctx.search && model.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(model.value, (option) => {
              return (_openBlock(), _createBlock(TagName, {
                onClick: ($event: any) => (toggleAndDeselect(option, false))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(option) + " ", 1 /* TEXT */),
                  _createVNode(Icon, { name: "dropdownOptionTagRemove" })
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]))
            }), 256 /* UNKEYED_FRAGMENT */))
          ]))
        : _createCommentVNode("v-if", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredOptions.value, (option, index) => {
        return (_openBlock(), _createBlock(CheckBox, {
          ref_for: true,
          ref: el => setOptionItem(option, el as unknown as OptionElement),
          key: option.value,
          label: option.title,
          icon: option.icon,
          class: _normalizeClass(['mb-0 pl-0 p-2 rounded', {'bg-tile-nested': index === selectedItemIndex.value}]),
          "model-value": selected(option.value),
          "onUpdate:modelValue": newValue => toggleAndDeselect(option.value, newValue)
        }, null, 8 /* PROPS */, ["label", "icon", "class", "model-value", "onUpdate:modelValue"]))
      }), 128 /* KEYED_FRAGMENT */)),
      (allFilteredOut.value)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, " Brak ofert z \"" + _toDisplayString(searchPhrase.value.trim()) + "\". ", 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["nested", "test-id", "title", "icon", "blip", "open-to-left"]))
}
}

})